import { render, staticRenderFns } from "./MastheadDropdown.vue?vue&type=template&id=fadf1a32"
import script from "./MastheadDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MastheadDropdown.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports